import React from 'react';
import styled from 'styled-components/macro';

import { useFormatMessage } from 'components/IntlProvider';
import { ReactComponent as InfoIcon } from 'assets/icons/infoIcon.svg';

const StyledNotification = styled.div`
  background-color: #e8effc;
  color: #253858;
  min-height: 3.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 1.375rem 2rem 1.375rem 1.16rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

const NotificationContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconContainer = styled.div`
  width: 1rem;
  margin-right: 0.66rem;
  display: flex;
  align-items: center;
`;

type ProjectStatusNotificationProps = {
  isManualDataCollection?: boolean;
  noData?: boolean;
};

const DataCollectionCompletedNotification = ({
  isManualDataCollection,
  noData,
}: ProjectStatusNotificationProps) => {
  const t = useFormatMessage();

  const getStatusText = () => {
    if (isManualDataCollection && noData) {
      return t(
        'dataCollection.notification.manual.complete.noData',
        'The project was completed before any data had been collected.'
      );
    } else if (isManualDataCollection) {
      return t(
        'dataCollection.notification.manual.complete',
        'Data collection is now complete. Data from surveys is no longer collected. '
      );
    } else {
      return t(
        'dataCollection.notification.complete',
        'Data collection is complete. You can view all collected data in a report.'
      );
    }
  };

  return (
    <div>
      <StyledNotification>
        <NotificationContent>
          <IconContainer>
            <InfoIcon />
          </IconContainer>
          <span>{getStatusText()}</span>
        </NotificationContent>
      </StyledNotification>
    </div>
  );
};

export default DataCollectionCompletedNotification;
